import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/App';
import NotFoundPage from './containers/NotFoundPage.js';
import Benjaminak from './containers/Benjaminak';
import Alebinak from './containers/Alebinak';
import Infantilak from './containers/Infantilak';
import Boxeak from './containers/Boxeak';
import Dashboard from './containers/DashboardPage';
import Materiala from './containers/Materiala';
import ZerDaDuatloia from './containers/ZerDaDuatloia';
import GureTaldea from './containers/GureTaldea';
import Egutegia from './containers/Egutegia';
import Sailkapenak from './containers/Sailkapenak';

export default (
  <Route>
    <Route path="/" 
           component={App}
           onChange={(prevState, nextState) => {
              if (nextState.location.action !== "POP") {
                window.scrollTo(0, 0);
              }
            }}>
      <IndexRoute component={Dashboard}/>
      <Route path="programazioa" component={Dashboard}/>
      <Route path="benjaminak" component={Benjaminak}/>
      <Route path="alebinak" component={Alebinak}/>
      <Route path="infantilak" component={Infantilak}/>
      <Route path="boxeak" component={Boxeak}/>
      <Route path="zerdaduatloia" component={ZerDaDuatloia}/>
      <Route path="materiala" component={Materiala}/>
      <Route path="egutegia" component={Egutegia}/>
      <Route path="guretaldea" component={GureTaldea}/>
      <Route path="sailkapenak" component={Sailkapenak}/>
      <Route path="*" component={NotFoundPage}/>
    </Route>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/